import React, {Component} from 'react';
import without from 'lodash/without';

class FilterPanel extends Component {
  state = {
    open: false,
  };

  _handleHeaderClick = () => this.setState({open: !this.state.open});

  _handleCheckboxChange = (evt) => {
    const {selected} = this.props;
    const {name, checked} = evt.target;
    const newSelected = checked ?
      [...selected, name] :
      without(selected, name);

    this.props.onChange(newSelected);
  };

  render() {
    const {title, values = [], selected = []} = this.props;
    const open = this.state.open;

    return (
      <section className='c-PartFilters__property'>
        <header className='c-PartFilters__property-title' onClick={this._handleHeaderClick}>
          <span className='c-PartFilters__nav-title'>
            {title}
          </span>
          <span className='c-PartFilters__arrow'>
            <img
              src={
                open
                  ? '/themes/app/assets/images/filter-arrow-up.svg'
                  : '/themes/app/assets/images/filter-arrow-down.svg'
              }
            />
          </span>
        </header>
        <div className='c-PartFilters__property-values' style={{display: open ? 'block' : 'none'}}>
          {values.map((value, idx) => (
            <div key={idx}>
              <input
                type='checkbox'
                name={value}
                checked={selected.includes(value)}
                onChange={this._handleCheckboxChange}
              />

              <span>{value}</span>
            </div>
          ))}
        </div>
      </section>
    );
  }
}

export default FilterPanel;



// WEBPACK FOOTER //
// ./plugins/app/site/pagesections/product/js/FilterPanel.js